<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/appprotectt-lite",
		    "name": "AppProtectt Lite"
		  }
		}		]
	}
	</script>

<!-- Breadcrumbs Start -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>AppProtectt Lite</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}} </h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                    <a class="btn-rectangle btn-transparent btn" data-toggle="modal"
                        data-target="#modalContactForm">Request A Demo</a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none subbanner" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
                <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request
                    A Demo</a>
                <a class="btn-rectangle btn-transparent btn ml-2" href="tel:8850106650">
                    <!-- <i class="fa fa-phone" aria-hidden="true"></i>  -->
                    <img src="assets/images/app-protectt/phone_icon.png" alt="Phone">
                    +91-8850106650
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray pt-4 section-pb-60">
    <div class="container d-flex">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="agency-benefits">
                    <div class="content">
                        <p>The Startup and MSME eco-systems are contributing to the global economy on an unprecedented
                            scale. The growth of these new-age entities is propelled by the habitual transformation of
                            Mobile Device usage amongst the end-users. Mobile App became instrumental to drive business,
                            Which stipulates the maximum time and energy in stargazing Mobile-First market demand.</p>
                        <p>Companies have evolved over the years in mastering the UI-UX and continue to invest in
                            further enhancements to stay ahead of competitors. At the same time they have an important
                            area to focus on - Cyber Security, If not done right it will have a huge impact on the
                            business from Data to financial loss, Which may make a dent in the reputation irreversibly.
                        <p>At Protectt.ai we understand the Cyber Security needs of Emerging Startups and MSMEs,
                            For them, Setting up a dedicated cyber security team is not financially viable, On the other
                            hand, the enterprise engineers are not having the right skills and time to implement robust
                            cyber security solutions. AppProtectt Lite is designed to empower the community to deal with
                            the Cyber Security demands and enable them to channelize the energy into developing the
                            business requirements.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="agency-thumb">
                    <div class="thumb" style="display: flex; align-content: center; justify-content: center;">
                        <img src="assets/images/app-protectt/app-protectt_m.webp" alt="Secure Mobile Application with Cyber Security" class="og_image_url" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Other Features -->
<section class="wrapper-card">
    <div class="container-fostrap">
        <div class="content">
            <div class="container appprotecttlitecard">
                <div class="row mt-30">
                    <div class="col-lg-12">
                        <div class="section-title text-center">
                            <h2>In-App Protection</h2>
                        </div>
                        <p class="mt-20" style="text-align: center;">
                            AppProtectt Lite offers innovative Runtime Application Self Protection (RASP) that is
                            automated,
                            intelligent and self-defending and proven to keep you safe from:
                        </p>
                    </div>
                </div>
                <!-- 1st row -->
                <div class="row mt-30">
                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">code_off</span></li>
                                </ul>
                                <h4 class="card-title">
                                    Debugging
                                </h4>
                                <p class="mt-3 center-text">
                                    AppProtectt Lite adds anti-debugging protection to your meticulously
                                    developed<span class="debugging dots">...</span><span class="more debugging">
                                        app
                                        that
                                        secures it from debugging tools that may attempt to read your source code.
                                        It blocks
                                        native and Java debugging tools from attaching to your iOS or Android app
                                        and
                                        actively detects any dynamic injection code manipulations performed during
                                        run-time.</span>
                                </p>
                                <a (click)="myFunction('debugging')" id="debugging-btn" class="myBtn">Read More
                                    ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">webhook</span></li>
                                </ul>
                                <h4 class="card-title">
                                    Hooking
                                </h4>
                                <p class="mt-3 center-text">
                                    Hooking is an increasing threat in mobile apps as hackers attempt to intercept<span
                                        class="hooking dots">...</span><span class="more hooking"> and
                                        manipulate the run-time business logic of your app without the need to access
                                        the
                                        source code. Bypassing the business logic can result in a loss of revenue for
                                        your
                                        organisation and increases the risk for data and financial fraud of your users.
                                        App
                                        Protectt hardens and protects your mobile app and hinders any external tampering
                                        of your original function logic.</span>
                                </p>
                                <a (click)="myFunction('hooking')" id="hooking-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">mobile_screen_share</span></li>
                                </ul>
                                <h4 class="card-title">
                                    Spoofing
                                </h4>
                                <p class="mt-3 center-text">
                                    Mobile apps are susceptible to sophisticated spoofing attacks which allow other<span
                                        class="spoofing dots">...</span><span class="more spoofing"> apps
                                        to assume the
                                        identity of the original app. Hackers exploit this technique to gain
                                        control of users’ sensitive login information or transactional details.
                                        AppProtectt
                                        Lite
                                        prevents a malicious app from gaining control and detects whether any app
                                        installed
                                        is harmful to your business application.</span>
                                </p>
                                <a (click)="myFunction('spoofing')" id="spoofing-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons"> handyman</span></li>
                                </ul>
                                <h4 class="card-title">
                                    Reverse<br />Engineering
                                </h4>
                                <p class="mt-3 center-text">
                                    Reverse Engineering allows hackers to analyse a compiled app and<span
                                        class="reverse dots">...</span><span class="more reverse">
                                        extract information
                                        about its source code. They can then leverage the source code to
                                        execute an attack, access proprietary information, expose vulnerabilities
                                        or repack and redistribute a malicious version to a targeted victim. Your source
                                        code is
                                        at the core of your business operations and AppProtectt Lite acts as the first
                                        line
                                        of
                                        defence in safeguarding it against threats.</span>
                                </p>
                                <a (click)="myFunction('reverse')" id="reverse-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="offset-lg-4"></div>
                    <div class="col-md-4 col-lg-3 mrgnleftb5">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><span class="material-icons">camera_front</span></li>
                                </ul>
                                <h4 class="card-title">
                                    Man-in-the-Middle Attacks
                                </h4>
                                <p class="mt-3 center-text">
                                    In today’s privacy-focused world, the safety of user data is vital. With the
                                    increasing flow<span class="mitm dots">...</span><span class="more mitm"> of data
                                        between end-users and your app server, Man-in-the-Middle
                                        Attacks try to gain access to and preview information within a secured
                                        communication channel. AppProtectt Lite safeguards your private communications
                                        and
                                        sensitive information against such malicious attacks.</span>
                                </p>
                                <a (click)="myFunction('mitm')" id="mitm-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Comprehensive In-App Protection -->


<!-- Start Agency Benefits Area -->
<div class="container">
    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <!-- <img style="border-radius: 10px;" src="assets/images/app-protectt/AppProtectt-aio.png" alt="" /> -->
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-aio.webp" alt="Latest All in One Mobile App Security 
                        for Iphone" />
                </div>
            </div>
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>All In One Mobile App Security</h3>
                    <p>Accelerate your mobile app security infrastructure with AppProtectt Lite. Just like legacy
                        desktop and
                        laptop software, mobile apps need to be secured against malicious attacks, now more than ever
                        before. AppProtectt Lite injects comprehensive,
                        360-degree security that enables Runtime Application Self Protection (RASP) for advanced
                        detection and mitigation of all types of mobile threats - from app tampering to being reverse
                        engineered. We help your organisation offload
                        security concerns enabling you to focus on developing your main business logic.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- /.row -->

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img mt-15">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-compromised.webp" alt="Mobile Application Security Assessment" />
                </div>
            </div>
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Safeguard Your App - Even On Compromised Devices</h3>
                    <p>Traditional cybersecurity tools are focused on fixed endpoints such as the local servers,
                        desktops and laptops. AppProtectt Lite extends this to your user’s mobile device to bridge a
                        gaping
                        hole in your security infrastructure. Smartphones
                        are still a young, a constantly evolving environment that requires modern, dynamic solutions
                        that not only prevent threats but are also equipped with detection and response capabilities. We
                        ensure that your organisation, your app
                        and your users stay protected while respecting the privacy of your data.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- /.row -->

    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/app-protectt/AppProtectt-network-security.webp" alt="Best Mobile Network Security App" />
                </div>
            </div>
            <!-- <img src="assets/images/about/realtime-protection.webp" alt="realtime-protection" class="img-60" /> -->
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6 order-md-1">

            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Zero Trust Network Security</h3>
                    <p>Whether you have a B2B or a B2C mobile app and whether your end users are consumers or your own
                        employees, AppProtectt Lite ensures that you are always in control of app security even when
                        being
                        used outside your control. We secure your
                        app with a zero-trust approach - continuously hunting for malicious attacks and threats even
                        when it is being accessed beyond the perimeter of your legacy network security.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Other Features -->
<div class="section-agency-benefit bg-gray section-pb-60 mt-50">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>Why Startups Choose Us</h2>
                </div>
            </div>
        </div>
        <div class="container w-100">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon yellow">
                            <div class="front-content">
                                <img src="assets/images/about-mobile-security/final-icons/1.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Cost-Effective</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Cost-Effective</h3>
                            <p>Minimize the cost of development involved with time, resources and effort that goes into
                                developing security capabilities in-house. AppProtectt Lite packs over 50 security
                                features in an easy-to-install package on a subscription
                                basis.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <img src="assets/images/about-mobile-security/final-icons/2.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Standardised Security</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Standardised Security</h3>
                            <p>Get access to the top-of-the-line, enterprise safety software by subscribing to
                                AppProtectt Lite. With standardised threat mitigation across all sectors, our AI-driven
                                security cloud ensures that you stay protected against
                                any threat out there.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <img src="assets/images/about-mobile-security/final-icons/5.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-3">Regulatory Compliance</h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <h3>Regulatory Compliance</h3>
                            <p>With increasing regulation in mobile app technology, AppProtectt Lite helps your
                                organisation ensure that your app security is always in compliance. We are constantly
                                updating security protocols to meet the most stringent regulations
                                and legal frameworks.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 content text-center">
            <!-- <a class="btn-circle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a> -->
            <a class="btn-rectangle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a>
        </div>
    </div>
</div>
<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div style="background: #163e6f" class="p-2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()"
                    #closebutton>
                    <span style="color: #fff" aria-hidden="true">&times;</span>
                </button>
                <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                    Contact Us
                </h4>
                <h6 style="color: #fff">Get ready to enhance your Mobile App Security effortlessly</h6>
            </div>
            <!-- <div style="display: block" class="modal-header text-center">
                    <p class="formparagraph1">Protectt.ai Labs cherish your excellent decision Talk to Protectt.ai Labs
                        to
                        learn more about how we can secure your mobile app and its data, by filling out the form below.
                        For
                        product support, please visit our·contact sales page.
                    </p>
                </div> -->
            <div class="modal-body mx-3">
                <form [formGroup]="demoForm" class="contactusform">
                    <div class="row">

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
                            <input type="text" placeholder="Enter Your Name" id="form34"
                                class="form-control validate input" formControlName="name" name="name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
                            <input type="email" placeholder="Enter Your Email " formControlName="email"
                                class="form-control input" id="email" name="email"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email
                                </div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                Number*</label>
                            <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                class="form-control validate input" formControlName="contactnumber" name="contactnumber"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                </div>
                                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                    Mobile
                                    Number.
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
                            <input type="text" placeholder="Enter Your Company Name" id="form34"
                                class="form-control validate input" formControlName="company_name" name="company_name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right"
                                for="form34">Designation*</label>
                            <input type="text" placeholder="Enter Your Designation" id="form34"
                                class="form-control validate input" formControlName="designation" name="designation"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name
                                </div>
                            </div>
                        </div>
                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                Slot
                                1*</label>
                            <input type="datetime-local" id="form34" class="form-control validate input"
                                formControlName="time_slot1" name="time_slot1"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row">
                            <div class="md-form mb-20 col-md-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                    Slot
                                    1*</label>
                                <input type="datetime-local" id="form34" class="form-control validate input"
                                    formControlName="time_slot1" name="time_slot1"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
                                </div>
                            </div>
                            <div class="md-form mb-20 col-md-6">
                                <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                    Slot
                                    2*</label>
                                <input type="datetime-local" id="form34" class="form-control validate input"
                                    formControlName="time_slot2" name="time_slot2"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
                                </div>
                            </div>
                        </div> -->
                    <div class="md-form">
                        <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
                            you?</label>
                        <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
                            class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
                    </div>
                    <div class="modal-footer d-flex justify-content-center">
                        <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"
                            (click)="onReset()">
                            Cancel
                        </button>
                        <!-- <button class="btn btn-secondary" type="reset" (click)="onReset()">Cancel</button> -->
                    </div>
                </form>
                <!-- <p style="color: #000">{{ message }}</p> -->
            </div>
        </div>
    </div>
</div>
<!-- <div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div style="background: #163e6f" class="p-2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()"
                    #closebutton>
                    <span style="color: #fff" aria-hidden="true">&times;</span>
                </button>
                <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                    Contact Us
                </h4>
                <h6 style="color: #fff">Discuss your cyber security needs</h6>
            </div>
            <div style="display: block" class="modal-header text-center">
                <p class="formparagraph1">Protectt.ai Labs cherish your excellent decision Talk to Protectt.ai Labs
                    to
                    learn more about how we can secure your mobile app and its data, by filling out the form below.
                    For
                    product support, please visit our contact sales page.
                </p>
            </div>
            <div class="modal-body mx-3">
                <form [formGroup]="demoForm" class="contactusform">
                    <div class="row">

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
                            <input type="text" placeholder="Enter Your Name" id="form34"
                                class="form-control validate input" formControlName="name" name="name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
                            <input type="email" placeholder="Enter Your Email " formControlName="email"
                                class="form-control input" id="email" name="email"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                Number*</label>
                            <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                class="form-control validate input" formControlName="contactnumber" name="contactnumber"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                </div>
                                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                    Mobile
                                    Number.
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
                            <input type="text" placeholder="Enter Your Company Name" id="form34"
                                class="form-control validate input" formControlName="company_name" name="company_name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Designation*</label>
                            <input type="text" placeholder="Enter Your Designation" id="form34"
                                class="form-control validate input" formControlName="designation" name="designation"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                Slot
                                1*</label>
                            <input type="datetime-local" id="form34" class="form-control validate input"
                                formControlName="time_slot1" name="time_slot1"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
                            </div>
                        </div>
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                                Slot
                                2*</label>
                            <input type="datetime-local" id="form34" class="form-control validate input"
                                formControlName="time_slot2" name="time_slot2"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="md-form">
                        <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
                            you?</label>
                        <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
                            class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
                    </div>
                    <div class="modal-footer d-flex justify-content-center">
                        <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"
                            (click)="onReset()">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div> -->